import { PopoverClose } from '@radix-ui/react-popover';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../../../../components';
import { ScrollSelect } from './ScrollSelect';
import { hoursOptions, minutesOptions } from './TimePicker.utils';

export interface TimePickerProps {
  selected: Date | null;
  setOpenedState: (state: boolean) => void;
  handleTimeChange: (type: 'hour' | 'minute', value: string) => void;
  topLabel: string;
  confirmLabel: string;
  onBackToDateSelection: () => void;
}

export const TimePicker = ({
  selected,
  setOpenedState,
  handleTimeChange,
  topLabel,
  confirmLabel,
  onBackToDateSelection,
}: TimePickerProps) => {
  return (
    <div className="xs:w-[350px] flex w-[calc(100vw-30px)] flex-col gap-3 px-3 pb-4">
      <div className="text-primary border-border flex flex-row items-center gap-2 border-b py-4">
        <Button size="custom" variant="ghost" onClick={onBackToDateSelection}>
          <ChevronLeft className="size-5.5" />
        </Button>

        <span className="text-sm leading-4">{topLabel}</span>
      </div>
      <div className="flex w-full flex-row justify-center divide-x">
        <div className="flex w-full flex-row items-center">
          <ScrollSelect
            options={hoursOptions}
            value={selected?.getHours() || 0}
            onChange={value => handleTimeChange('hour', value)}
          />
          <span className="text-xl">:</span>

          <ScrollSelect
            options={minutesOptions}
            value={selected?.getMinutes() || 0}
            onChange={value => handleTimeChange('minute', value)}
          />
        </div>
      </div>
      <PopoverClose onClick={() => setOpenedState(false)} asChild>
        <Button variant="outline">{confirmLabel}</Button>
      </PopoverClose>
    </div>
  );
};
